import { AfterViewInit, ChangeDetectionStrategy, Component, inject, Inject, OnInit, ViewEncapsulation } from '@angular/core';
import { CustomerNotificationService } from '../main-page/customer-notification.service';
import { TranslocoModule } from '@jsverse/transloco';
import { EnvConfigService } from '../../core/services/env-config.service';

@Component({
  selector: 'dl-nondialog-customer-welcome',
  standalone: true,
  imports: [TranslocoModule],
  templateUrl: './nondialog-customer-welcome.component.html',
  styleUrl: './nondialog-customer-welcome.component.scss',
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class NondialogCustomerWelcomeComponent implements OnInit, AfterViewInit {
  envConfigService = inject(EnvConfigService);
  public notificationData:any;
  public customerservice = inject(CustomerNotificationService);
  public constructor() {
    this.notificationData = history.state.notificationData;
  }

  public ngOnInit(): void {}
  
  public ngAfterViewInit(): void {
    const localId = this.notificationData ? this.notificationData.LocalId : '';
    this.customerservice.setLocalId(localId);
  }

  openLink(href: string, openInNewTab?: boolean): void {
    const a = document.createElement('a');
    a.href = href;
    a.setAttribute('referrerpolicy', 'no-referrer-when-downgrade');
    if (openInNewTab) {
      a.setAttribute('target', '_blank');
    }
    a.style.display = 'none';
    document.body.appendChild(a);
    a.click();
  }
}
